import { RiMessage2Fill } from '@react-icons/all-files/ri/RiMessage2Fill'

// promo header text

export const IconMessage = RiMessage2Fill
